function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable react/no-unused-prop-types */
import React, { useCallback, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Label, Row } from 'reactstrap';
import momentTimezone from 'moment-timezone';
import validator from 'validator';
import withJobActions from './withJobActions';
import { combineDocuments, reduceDocuments } from '../../../documents/documentSelectors';
import DateTimePicker from '../../../common/controls/dateTimePicker';
import DocumentsUploadPicker from '../../../documents/documentsUploadPicker';
import entityComposition from '../../../common/classes/entityComposition';
import MultiPicker from '../../../common/controls/multiPicker';
import SingleOtherPicker from '../../../common/controls/singleOtherPicker';
import SegmentedPicker from '../../../common/controls/segmentedPicker';
import SinglePicker from '../../../common/controls/singlePicker';
import TextInput from '../../../common/controls/textInput';
const makeNames = (nameArray = []) => nameArray.map(person => {
  const result = person;
  if (!result.name) {
    result.name = `${person.firstName} ${person.lastName}`;
  }
  return result;
});
const selectAllEntity = {
  name: '-- Select All --',
  identifier: 'selectAllEmployees'
};
const JobGeneralSubsection = ({
  active: _active = {
    contractRequirements: {}
  },
  orgSelectJob,
  state,
  country,
  generalManager,
  projectManager,
  foreman,
  jobGeneralEmployee,
  reportTypeSelectJob,
  documentSelectJob,
  documentSelectJobActions,
  jobGeneralEmployeeActions,
  foremanActions,
  generalManagerActions,
  orgSelectJobActions,
  projectManagerActions,
  stateActions,
  countryActions,
  userID,
  onChange: onFormChange,
  onJobChange,
  reportTypeSelectJobActions
}) => {
  useEffect(() => {
    countryActions.serverIndex(country.indexQuery);
    documentSelectJobActions.serverIndex(documentSelectJob.indexQuery);
    jobGeneralEmployeeActions.serverIndex(jobGeneralEmployee.indexQuery);
    foremanActions.serverIndex(foreman.indexQuery);
    generalManagerActions.serverIndex(generalManager.indexQuery);
    projectManagerActions.serverIndex(projectManager.indexQuery);
    reportTypeSelectJobActions.serverIndex(reportTypeSelectJob.indexQuery);
    stateActions.serverIndex(state.indexQuery);
    orgSelectJobActions.serverIndex(orgSelectJob.indexQuery);
  }, [country.indexQuery, countryActions, documentSelectJob.indexQuery, documentSelectJobActions, foreman.indexQuery, foremanActions, generalManager.indexQuery, generalManagerActions, jobGeneralEmployee.indexQuery, jobGeneralEmployeeActions, orgSelectJob.indexQuery, orgSelectJobActions, projectManager.indexQuery, projectManagerActions, reportTypeSelectJob.indexQuery, reportTypeSelectJobActions, state.indexQuery, stateActions]);
  const changeFunctions = useMemo(() => {
    const result = {};
    ['countryID', 'foremen', 'generalManagerID', 'isCertified', 'isClosed', 'organizations', 'projectManagers', 'reportTypes', 'startStamp', 'timeZoneName'].forEach(attribute => {
      result[attribute] = value => onJobChange(attribute, value);
    });
    return result;
  }, [onJobChange]);

  /**
     * When a document is removed, rebuild the reportDocument list and ensure autoAssociateToReport
     * is preserved for those entities
     */
  const handleDocumentChange = useCallback((incomingDocuments = []) => {
    const oldDocuments = _active.documents || [];
    const oldReportDocuments = oldDocuments.filter(doc => doc.autoAssociateToReport);

    // get new ReportDocuments by determining if a LibraryDocument was removed,
    // then add the autoAssociateToReport flag
    const newReportDocuments = reduceDocuments(oldReportDocuments, incomingDocuments).map(doc => _objectSpread(_objectSpread({}, doc), {}, {
      autoAssociateToReport: 1
    }));

    // combine the new "reportDocuments" and new documents
    onJobChange('documents', combineDocuments(newReportDocuments, incomingDocuments));
  }, [_active.documents, onJobChange]);

  /**
   *  For jobNumber, write both to the relational record via onJobChange and send a Form
   *  change event to update content
   */
  const handleJobNumberChange = useCallback((contentPath, value) => {
    onFormChange({
      path: '/title',
      value
    });
    onJobChange(contentPath, value);
  }, [onFormChange, onJobChange]);

  /**
   *  For each selected document, set the autoAssociateToReport flag
   */
  const handleReportDocumentChange = useCallback((incomingReportDocuments = []) => {
    // clear all existing associations. This method will be called with the set of selections, which
    // can be empty if all associations need to be cleared.
    const documents = (_active.documents || []).map(doc => _objectSpread(_objectSpread({}, doc), {}, {
      autoAssociateToReport: 0
    }));

    // set the flag for all selections
    const reportDocuments = incomingReportDocuments.map(doc => _objectSpread(_objectSpread({}, doc), {}, {
      autoAssociateToReport: 1
    }));
    onJobChange('documents', combineDocuments(reportDocuments, documents));
  }, [_active.documents, onJobChange]);
  const handleStateChange = useCallback(value => {
    let validValue = ''; // validator requires a string and throws error on null
    if (value !== null) {
      validValue = value;
    }
    let stateID = null;
    let stateOther = null;
    if (validator.isUUID(validValue)) {
      stateID = validValue;
    } else {
      stateOther = validValue;
    }
    onJobChange('stateID', stateID);
    onJobChange('stateOther', stateOther);
  }, [onJobChange]);
  const documents = _active.documents || [];
  // make sure we have a name value for all employees.  If they are inactive,
  // we won't have an entity to match them up with in the list, so we need
  // to use the name.
  const employees = makeNames(_active.employees);
  const foremen = makeNames(_active.foremen);
  const projectManagers = makeNames(_active.projectManagers);
  const reportDocuments = documents.filter(doc => doc.autoAssociateToReport);
  const timezones = momentTimezone.tz.names().map(name => ({
    id: name,
    name
  }));

  // if not new, and we have not got the "isClosed" property, then
  // we still have tno received data back from the server.  so,
  // don't display other stuff until that happens.
  if (!_active.isNew && typeof _active.isClosed === 'undefined') {
    // no data loaded yet,
    return /*#__PURE__*/React.createElement("div", null, "loading...");
  }
  const employeeOptions = makeNames(jobGeneralEmployee.list);

  // Determine if there are any employee options left unselected, if so, add select all entity
  const selectedEmployeeIDs = employees.map(({
    id
  }) => id);
  const unSelectedOptions = employeeOptions.filter(({
    id
  }) => !selectedEmployeeIDs.includes(id));
  const employeePickerOptions = unSelectedOptions.length ? [selectAllEntity, ...employeeOptions] : employeeOptions;
  const handleEmployeeChange = values => {
    const selected = values.some(({
      identifier
    }) => identifier === selectAllEntity.identifier) ? employeeOptions : values;
    onJobChange('employees', selected);
  };
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: "12"
  }, /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("h2", null, "General"), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(MultiPicker, {
    label: "Organizations",
    options: orgSelectJob.list,
    values: _active.organizations,
    labelKey: "name",
    placeholder: "Select...",
    onChange: changeFunctions.organizations
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Job Number",
    field: "jobNumber",
    data: _active,
    onChange: handleJobNumberChange,
    entity: "Job",
    placeholder: "Required"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(DateTimePicker, {
    onChange: changeFunctions.startStamp,
    label: "Start Date",
    defaultValue: _active.startStamp
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(SegmentedPicker, {
    names: ['Open', 'Closed'],
    values: [0, 1],
    label: "Status",
    allowNull: false,
    onChange: changeFunctions.isClosed,
    value: _active.isClosed
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(SegmentedPicker, {
    names: ['Yes', 'No'],
    values: [1, 0],
    label: "Certified",
    onChange: changeFunctions.isCertified,
    value: _active.isCertified
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "SAP ID",
    field: "sapID",
    data: _active,
    onChange: onJobChange,
    entity: "Job"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Job Name",
    field: "name",
    data: _active,
    onChange: onJobChange,
    entity: "Job"
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "City",
    field: "city",
    data: _active,
    onChange: onJobChange,
    entity: "Job"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(SingleOtherPicker, {
    label: "State / Province",
    labelKey: "name",
    onChange: handleStateChange,
    options: state.list,
    placeholder: "Select...",
    returnValueKey: "id",
    value: _active.stateID || _active.stateOther
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(SinglePicker, {
    label: "Country",
    options: country.list,
    value: _active.countryID,
    labelKey: "name",
    returnValueKey: "id",
    placeholder: "Select...",
    onChange: changeFunctions.countryID
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Location Description",
    field: "note",
    data: _active,
    onChange: onJobChange,
    entity: "Job"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(SinglePicker, {
    label: "Time Zone",
    options: timezones,
    value: _active.timeZoneName,
    labelKey: "name",
    returnValueKey: "id",
    placeholder: "Select...",
    onChange: changeFunctions.timeZoneName
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(SinglePicker, {
    label: "General Manager",
    options: generalManager.list,
    value: _active.generalManagerID,
    labelKey: "name",
    returnValueKey: "id",
    placeholder: "Select...",
    onChange: changeFunctions.generalManagerID
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(MultiPicker, {
    label: "Project Managers",
    options: projectManager.list,
    values: projectManagers,
    labelKey: "name",
    placeholder: "Select...",
    onChange: changeFunctions.projectManagers
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 6
  }, /*#__PURE__*/React.createElement(MultiPicker, {
    label: "Foreman",
    options: foreman.list,
    values: foremen,
    labelKey: "name",
    placeholder: "Select...",
    onChange: changeFunctions.foremen
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement(MultiPicker, {
    label: "Employees",
    options: employeePickerOptions,
    values: employees,
    labelKey: "name",
    placeholder: "Select...",
    onChange: handleEmployeeChange
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12
  }, /*#__PURE__*/React.createElement(MultiPicker, {
    label: "Available Reports",
    options: reportTypeSelectJob.list,
    values: _active.reportTypes,
    labelKey: "name",
    placeholder: "Select...",
    onChange: changeFunctions.reportTypes
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12,
    className: "jobs-general-library-documents"
  }, /*#__PURE__*/React.createElement(Label, null, "Library Documents"), /*#__PURE__*/React.createElement(DocumentsUploadPicker, {
    document: documentSelectJob,
    documentActions: documentSelectJobActions,
    label: "",
    labelKey: "displayName",
    onChange: handleDocumentChange,
    options: documentSelectJob.list,
    selectedValues: documents,
    userID: userID,
    jobID: _active.isNew ? null : _active.id
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 12,
    className: "jobs-general-report-documents"
  }, /*#__PURE__*/React.createElement(Label, null, "Report Documents\xA0", /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '80%',
      fontStyle: 'itablic'
    }
  }, "(automatically added as Associated Documents to any report for this job)")), /*#__PURE__*/React.createElement(DocumentsUploadPicker, {
    document: documentSelectJob,
    documentActions: documentSelectJobActions,
    label: "",
    labelKey: "displayName",
    onChange: handleReportDocumentChange,
    options: documents,
    selectedValues: reportDocuments,
    userID: userID,
    jobID: _active.isNew ? null : _active.id
  }))))));
};
JobGeneralSubsection.propTypes = {
  active: PropTypes.shape({
    id: PropTypes.string,
    isNew: PropTypes.bool,
    isPending: PropTypes.bool,
    documents: PropTypes.arrayOf(PropTypes.shape({})),
    reportTypes: PropTypes.arrayOf(PropTypes.shape({})),
    timeZoneName: PropTypes.string,
    countryID: PropTypes.string,
    stateOther: PropTypes.string,
    stateID: PropTypes.string,
    isCertified: PropTypes.number,
    isClosed: PropTypes.number,
    sapID: PropTypes.string,
    startStamp: PropTypes.string,
    employees: PropTypes.arrayOf(PropTypes.shape({})),
    foremen: PropTypes.arrayOf(PropTypes.shape({})),
    projectManagers: PropTypes.arrayOf(PropTypes.shape({})),
    generalManagerID: PropTypes.string,
    generalManager: PropTypes.shape({}),
    organizations: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  country: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  countryActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  documentSelectJob: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  documentSelectJobActions: PropTypes.shape({
    serverIndex: PropTypes.func,
    serverSaveAll: PropTypes.func,
    serverUpload: PropTypes.func
  }).isRequired,
  jobGeneralEmployee: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  jobGeneralEmployeeActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  foreman: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  foremanActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  generalManager: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  generalManagerActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  orgSelectJob: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  orgSelectJobActions: PropTypes.shape({
    serverIndex: PropTypes.func,
    serverSaveAll: PropTypes.func,
    serverUpload: PropTypes.func
  }).isRequired,
  projectManager: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  projectManagerActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  reportTypeSelectJob: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  reportTypeSelectJobActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  state: PropTypes.shape({
    indexQuery: PropTypes.shape({}),
    list: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  stateActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  userID: PropTypes.string.isRequired,
  // from withJobActions
  onJobAdd: PropTypes.func.isRequired,
  onJobRemove: PropTypes.func.isRequired,
  onJobChange: PropTypes.func.isRequired
};
export { JobGeneralSubsection as UncomposedJobGeneralSubsection };
const JobGeneral = entityComposition(JobGeneralSubsection, ['country', 'documentSelectJob', 'jobGeneralEmployee', 'foreman', 'generalManager', 'projectManager', 'reportTypeSelectJob', 'state', 'orgSelectJob'], {});
export default withJobActions(JobGeneral);